import {
    ANALYZE_FOR_ENTRY_COMPONENTS,
    ModuleWithProviders,
    NgModule,
    NgModuleFactoryLoader,
    SystemJsNgModuleLoader,
    Type,
	InjectionToken,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ROUTES } from '@angular/router';

// import { DynamicComponentLoader } from './dynamic-component-loader.service';
import { DYNAMIC_COMPONENT, DYNAMIC_COMPONENT_MANIFESTS, DynamicComponentManifest } from './dynamic-component-manifest';
import { DynamicComponentLoaderService } from './dynamic-component-loader.service';

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		DynamicComponentLoaderService,
		{ provide: NgModuleFactoryLoader, useClass: SystemJsNgModuleLoader }
	],
	declarations: []
})

export class DynamicComponentLoaderModule { 
	static forRoot(manifests: DynamicComponentManifest[]): ModuleWithProviders {
		return {
		  ngModule: DynamicComponentLoaderModule,
		  providers: [
			// provider for Angular CLI to analyze
			{ provide: ROUTES, useValue: manifests, multi: true },
			{ provide: DYNAMIC_COMPONENT_MANIFESTS, useValue: manifests }
		  ],
		};
	  }
}



// WEBPACK FOOTER //
// ./src/app/common/dynamic-component-loader/dynamic-component-loader.module.ts